export const Config = {
    //API: 'http://35.240.219.164:89/api/'
    API: 'https://uat.travelsafecoachhire.com.au/api/',
    //API: 'https://travelsafecoachhire.com.au/api/',
}
